import { useEffect, useState, useCallback } from "react";
import { useNavigate, useSearchParams, Link } from "react-router-dom";
import GoogleAuthPanel from "./components/GoogleAuthPanel";
import {
  persistAuthRedirectFromSearch,
  getAuthRedirectTarget,
  clearAuthRedirect,
  signinHrefWithRedirect,
} from "./utils/authRedirect";

export default function SignUpPage({ isDarkMode }) {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [error, setError] = useState("");
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const googleClientId = process.env.REACT_APP_GOOGLE_CLIENT_ID || "";
  const redirectParam = searchParams.get("redirect") || "";

  useEffect(() => {
    persistAuthRedirectFromSearch(searchParams);
  }, [searchParams]);

  const onGoogleSuccess = useCallback(() => {
    const dest = getAuthRedirectTarget(searchParams);
    clearAuthRedirect();
    navigate(dest);
  }, [navigate, searchParams]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("Email/password sign up is temporarily disabled. Please use Google.");
  };

  const signinHref = signinHrefWithRedirect(redirectParam);

  return (
    <div
      style={{
        padding: "24px 16px",
        maxWidth: "520px",
        margin: "0 auto",
        width: "100%",
        minHeight: "calc(100vh - 180px)",
        color: isDarkMode ? "#fff" : "#111827",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      <div
        style={{
          width: "100%",
          background: isDarkMode ? "#111827" : "#ffffff",
          border: `1px solid ${isDarkMode ? "#374151" : "#e5e7eb"}`,
          borderRadius: "16px",
          padding: "24px",
          boxShadow: isDarkMode
            ? "0 10px 28px rgba(0,0,0,0.35)"
            : "0 10px 28px rgba(17,24,39,0.08)",
        }}
      >
        <h1 style={{ textAlign: "center", marginBottom: "8px", fontSize: "28px" }}>
          Create Account
        </h1>
        <p
          style={{
            textAlign: "center",
            marginBottom: "20px",
            color: isDarkMode ? "#9ca3af" : "#6b7280",
          }}
        >
          Sign up instantly with Google
        </p>

        {googleClientId && (
          <div style={{ marginBottom: "18px" }}>
            <GoogleAuthPanel
              buttonId="google-signup-button"
              variant="signup_with"
              isDarkMode={isDarkMode}
              onSuccess={onGoogleSuccess}
              onError={(msg) => setError(msg)}
            />
          </div>
        )}

        {!googleClientId && (
          <p style={{ color: "#ef4444", textAlign: "center", marginBottom: "18px" }}>
            Google Client ID is not configured.
          </p>
        )}

        <div
          style={{
            textAlign: "center",
            margin: "14px 0 18px",
            color: isDarkMode ? "#9ca3af" : "#6b7280",
            fontSize: "14px",
          }}
        >
          Or use email/password (coming soon)
        </div>

        <form onSubmit={handleSubmit}>
          <div style={{ marginBottom: "12px" }}>
            <label style={{ display: "block", marginBottom: "6px" }}>Email</label>
            <input
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              disabled
              placeholder="you@example.com"
              style={{
                width: "100%",
                padding: "12px",
                border: `1px solid ${isDarkMode ? "#4b5563" : "#d1d5db"}`,
                borderRadius: "10px",
                backgroundColor: isDarkMode ? "#1f2937" : "#f9fafb",
                color: isDarkMode ? "#d1d5db" : "#6b7280",
                boxSizing: "border-box",
                opacity: 0.8,
              }}
            />
          </div>
          <div style={{ marginBottom: "12px" }}>
            <label style={{ display: "block", marginBottom: "6px" }}>Password</label>
            <input
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              disabled
              placeholder="********"
              style={{
                width: "100%",
                padding: "12px",
                border: `1px solid ${isDarkMode ? "#4b5563" : "#d1d5db"}`,
                borderRadius: "10px",
                backgroundColor: isDarkMode ? "#1f2937" : "#f9fafb",
                color: isDarkMode ? "#d1d5db" : "#6b7280",
                boxSizing: "border-box",
                opacity: 0.8,
              }}
            />
          </div>
          <div style={{ marginBottom: "14px" }}>
            <label style={{ display: "block", marginBottom: "6px" }}>Confirm Password</label>
            <input
              type="password"
              value={confirmPassword}
              onChange={(e) => setConfirmPassword(e.target.value)}
              disabled
              placeholder="********"
              style={{
                width: "100%",
                padding: "12px",
                border: `1px solid ${isDarkMode ? "#4b5563" : "#d1d5db"}`,
                borderRadius: "10px",
                backgroundColor: isDarkMode ? "#1f2937" : "#f9fafb",
                color: isDarkMode ? "#d1d5db" : "#6b7280",
                boxSizing: "border-box",
                opacity: 0.8,
              }}
            />
          </div>
          {error && <p style={{ color: "#ef4444", marginBottom: "12px" }}>{error}</p>}
          <button
            type="submit"
            disabled
            style={{
              width: "100%",
              padding: "12px",
              backgroundColor: "#9ca3af",
              color: "white",
              border: "none",
              borderRadius: "10px",
              cursor: "not-allowed",
              fontWeight: 600,
            }}
          >
            Email Sign Up (Disabled)
          </button>
        </form>
        <p style={{ textAlign: "center", marginTop: "18px" }}>
          Already have an account?{" "}
          <Link to={signinHref} style={{ color: "#2563eb", fontWeight: 600 }}>
            Sign In
          </Link>
        </p>
      </div>
    </div>
  );
}
